// Add a holiday when the product should support it in planning, settings, or allowance logic.
// `id` is the stable product key for translations and organisation settings.
// `rule` tells date-holidays-parser on which date the holiday occurs.
// `allowance_id` preserves the existing allowance contract until allowances store stable ids.
// DO NOT change `allowance_id` values without migrating existing allowance settings.

export const HOLIDAYS_TAXONOMY = [
	{id: 'new_years_day', rule: '01-01', allowance_id: 'Nieuwjaarsdag'},
	{id: 'valentines_day', rule: '02-14'},
	{id: 'good_friday', rule: 'easter -2'},
	{id: 'easter_sunday', rule: 'easter', allowance_id: 'Eerste Paasdag'},
	{id: 'easter_monday', rule: 'easter 1', allowance_id: 'Tweede Paasdag'},
	{id: 'kings_day', rule: '04-27 if sunday then previous saturday since 2014', allowance_id: 'Koningsdag'},
	{id: 'remembrance_day', rule: '05-04'},
	{id: 'liberation_day', rule: '05-05', allowance_id: 'Bevrijdingsdag'},
	{id: 'mothers_day', rule: '2nd sunday in May'},
	{id: 'ascension_day', rule: 'easter 39', allowance_id: 'Hemelvaartsdag'},
	{id: 'whit_sunday', rule: 'easter 49', allowance_id: 'Eerste Pinksterdag'},
	{id: 'whit_monday', rule: 'easter 50', allowance_id: 'Tweede Pinksterdag'},
	{id: 'fathers_day', rule: '3rd sunday in June'},
	{id: 'keti_koti', rule: '07-01'},
	{id: 'st_nicholas_eve', rule: '12-05'},
	{id: 'christmas_eve', rule: '12-24'},
	{id: 'christmas_day', rule: '12-25', allowance_id: 'Eerste Kerstdag'},
	{id: 'boxing_day', rule: '12-26', allowance_id: 'Tweede Kerstdag'},
	{id: 'new_years_eve', rule: '12-31'},
]
